import Checkbox from "@/components/LandingCheckboxes/Checkbox";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { SVGUnion } from "@/images/svg/svg-icons";

export default function Step2({
  questionsBlocks,
  answer,
  setAnswer,
  type,
  setSuccessStep,
  showError,
  error,
}: any) {
  const [showQuestion, setShowQuestion] = useState(1);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (answer.length === 1 && value === "No") {
      setShowQuestion(2);
    } else if (answer.length === 2 && value === "No") {
      setShowQuestion(3);
    }
    if (answer.every((i: any) => i.value === "No") && answer.length === 3) {
      showError(true);
    } else {
      showError(false);
    }
    if (answer.some((i: any) => i.value === "Yes")) {
      setSuccessStep(true);
    } else {
      setSuccessStep(false);
    }
  }, [answer, value]);

  return (
    <>
      {questionsBlocks.slice(0, showQuestion).map((question: any) => (
        <>
          <div className="p-4" key={question._uid}>
            <p className="text-main-black mb-8 md:text-left text-center">
              {question.title}
            </p>
            <div className="flex gap-4">
              {question.answers.map((i: string) => (
                <Checkbox
                  key={question._uid}
                  label={i}
                  id={question._uid}
                  name={question.title}
                  answer={answer}
                  setAnswer={setAnswer}
                  type={type}
                  setValue={setValue}
                />
              ))}
            </div>
          </div>
        </>
      ))}
      <p
        className={classNames(
          "text-[#EC1C2C] p-4 pb-6 flex items-center gap-x-2 text-base",
          error ? "block" : "hidden"
        )}
      >
        <div className="w-6 h-6">
          <SVGUnion />
        </div>
        Sorry, a security license is required for this position
      </p>
      <div className="hor-line"></div>
    </>
  );
}
